import { LOADING, SET_WEBSITE_LIST } from "../../Actions/Types";
import { getDomainListApi } from "../../Api/DomainApi/DomainListWithDetailsApi";
import { UpdateEUFlagDomainApi } from "../../Api/DomainApi/UpdateEUFlagDomainApi";

const UpdateEUFlagDomainService = async (
    token: string, // access token
    dispatch: Function, // dispatch function to store redux data
    websiteId: number, // website id
    is_eu_script_show: number, // is_eu_script_show flag
    is_eu_script_show_first: number, // is_eu_script_show_first flag
    no_required_eu: number, // no_required_eu flag
): Promise<any> => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to get domain list
    UpdateEUFlagDomainApi(token, websiteId, is_eu_script_show, is_eu_script_show_first, no_required_eu).then((listRes) => {
        // check if response is ok
        if (listRes.status === 200) {

            // Set Website List
            dispatch({
                type: SET_WEBSITE_LIST,
                payload: listRes.Data
            })

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });

        } else {

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    });

    return {status:200}

}

export { UpdateEUFlagDomainService }